module.exports = __webpack_public_path__ + "back-c06a4b0398629b14a6a0.png";